/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type React from 'react';
import {useEffect, useState} from 'react';
import {Form, Tab, Tabs, Button, InputGroup} from 'react-bootstrap';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import {useNavigate} from 'react-router-dom';

import LayoutMain from 'components/Layouts/LayoutMain';
import {
	useLazyGetSubscriptionDataPlanTemplateQuery,
	useLazyGetSubscriptionDataQuery,
	useLazyGetSubscriptionDataGpsiQuery,
	useLazyGetOperatorsDataPlanTemplateQuery,
} from 'services';
import type {DataPlanTemplate, ISubscriberProfile, Operator} from 'interfaces';
import TableSubscritionProfile from 'components/Tables/TableSubscritionProfile';
import TableSubscritionPlan from 'components/Tables/TableSubscritionPlan';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import {useAppSelector} from 'store/hooks';
import {RenderNoData} from 'components/RenderNoData';
import {RenderTabTitle} from 'components/RenderTabTitle';

TimeAgo.setDefaultLocale(en.locale);
TimeAgo.addLocale(en);

type TDataProfile = {
	type_search: string;
	valueOfFind: string;
	data: ISubscriberProfile | null;
};
type TDataPlan = {
	valueOfFind: string;
	data: DataPlanTemplate[] | [];
};
type TDataOperator = {
	data: Operator[] | [];
};

const TIME_INTERVAL_MS = 59000;

const SubscriberHome = () => {
	const navigate = useNavigate();

	const {state: stateSystem} = useAppSelector(
		state => state.systemConfigProperty,
	);
	const {roles} = useAppSelector(state => state.user);

	const isReadOnlySubscribers =
		roles.includes('subscriber_read_only') ||
		!roles.includes('subscriber_provision');

	const isReadOnlyPlan =
		roles.includes('plan_read_only') || !roles.includes('plan_provision');

	const isVolTE = stateSystem === 'VolTE';

	const [getSubscriptionProfile, {isLoading: isLoadingProfile}] =
		useLazyGetSubscriptionDataQuery();
	const [getSubscriptionProfileGpsi, {isLoading: isLoadingProfileGpsi}] =
		useLazyGetSubscriptionDataGpsiQuery();
	const [getDataPlanTemplate, {isLoading: isLoadingDataPlanTemplate}] =
		useLazyGetSubscriptionDataPlanTemplateQuery();
	const [getDataOperatorsTemplate] = useLazyGetOperatorsDataPlanTemplateQuery();

	const [initialDate, setInitialDate] = useState<Date>(new Date());
	const [timeStr, setTimeStr] = useState<string>('just now');
	const [key, setKey] = useState<string>('Search Profile');
	const [dataProfile, setDataProfile] = useState<TDataProfile>({
		type_search: 'supi',
		valueOfFind: '',
		data: null,
	});
	const [dataPlan, setDataPlan] = useState<TDataPlan>({
		valueOfFind: '',
		data: [],
	});
	const [dataOperators, setDataOperators] = useState<TDataOperator | any>({
		data: [],
	});
	const timeAgo = new TimeAgo('en-US');

	useEffect(() => {
		setKey(
			roles
				.find((str: string) => str?.includes('subscriber'))
				?.includes('subscriber')
				? 'Search Profile'
				: 'Search Plan',
		);
	}, [roles]);

	const handleCleanPlans = (item: DataPlanTemplate) => {
		setDataPlan(prevState => ({
			...prevState,
			data:
				prevState &&
				prevState?.data?.filter(
					(el: DataPlanTemplate) => el.name !== item.name,
				),
		}));
	};
	/**
	 * This function formats a given date as a string representing how long ago it was.
	 */
	const handleDateAgo = () => setTimeStr(timeAgo.format(initialDate));

	/* A custom hook that is used to update the time every 59 seconds. */
	useEffect(() => {
		const interval = setInterval(() => {
			handleDateAgo();
		}, TIME_INTERVAL_MS);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/* It's a hook that runs after the component is rendered. */
	useEffect(() => {
		setInitialDate(new Date());
		handleDateAgo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataProfile.data || dataPlan.data]);

	/**
	 * This function changes the value of a search input field based on the type of profile or plan being
	 * searched.
	 * @param e - React.ChangeEvent<HTMLInputElement> - This is an event object that is triggered when the
	 * value of an input element changes. It is a type defined by the React library.
	 * @param {string} type - The type parameter is a string that determines which state object to update.
	 * If it is equal to 'profile', the value of find in the dataProfile state object will be updated.
	 * Otherwise, the value of find in the dataPlan state object will be updated.
	 */
	const changeValueOfFind = (
		e: React.ChangeEvent<HTMLInputElement>,
		type: string,
	) => {
		const trimmedValue = e.target.value.trim();
		if (type === 'profile') {
			setDataProfile({...dataProfile, valueOfFind: trimmedValue});
		} else if (type === 'plan') {
			setDataPlan({...dataPlan, valueOfFind: trimmedValue});
		} else {
			setDataOperators({...dataPlan});
		}
	};

	/**
	 * This function updates the "type_search" property in the "dataProfile" object based on the selected
	 * option in a dropdown menu.
	 * @param  - The function `changeSelectOption` takes in a single parameter, which is an object that
	 * represents the event that triggered the function. Specifically, it is a `ChangeEvent` object that
	 * is specific to a `HTMLSelectElement`.
	 */
	const changeSelectOption = ({
		target,
	}: React.ChangeEvent<HTMLSelectElement>) => {
		const {value} = target;
		setDataProfile({...dataProfile, type_search: value});
	};

	/**
	 * This function handles form submission and retrieves subscription profile data.
	 * @param e - React.FormEvent - This is the event object that is triggered when the form is submitted.
	 * It contains information about the event, such as the target element, the type of event
	 * data associated with the event.
	 * @returns If the `if` condition is true and the function returns, nothing is being returned
	 * explicitly. If the `if` condition is false, the function returns the result of the
	 * `getSubscriptionProfile` function call, which is being unwrapped using the `unwrap` method.
	 */
	const handleSubmit = async (e: React.FormEvent, type: string) => {
		e.preventDefault();
		if (type === 'profile' && dataProfile.valueOfFind.trim() !== '') {
			setDataProfile({
				...dataProfile,
				data: await getSubscriptionProfile(dataProfile.valueOfFind).unwrap(),
			});
		} else if (type === 'plan') {
			const tmp =
				(await getDataPlanTemplate(dataPlan.valueOfFind).unwrap()) || [];
			setDataPlan({
				...dataPlan,
				data: tmp as never,
			});
		} else if (type === 'operator') {
			const tmp = (await getDataOperatorsTemplate(undefined).unwrap()) || [];
			setDataOperators({
				...dataOperators,
				data: tmp as never,
			});
		}
	};

	/**
	 * The function `handleRefetch` is an asynchronous function that retrieves a subscription profile
	 * using the `getSubscriptionProfile` function and updates the state with the retrieved data.
	 * @param {string} supi - The `supi` parameter is a string that represents the subscription profile
	 * identifier.
	 */
	const handleRefetch = async (supi: string) => {
		try {
			const res = await getSubscriptionProfile(supi).unwrap();
			setDataProfile(prevState => ({
				...prevState,
				data: res,
			}));
		} catch (error) {
			// eslint-disable-next-line no-console
			console.info(error);
		}
	};

	return (
		<LayoutMain>
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Subscriber Profile Management</h1>
					</div>
				</div>
				{/* Subscriber Profile Management */}
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-person-lines-fill mr-3 float-left text-primary bi-2-5" />
								<h2 className="card-title">Subscriber Profile Management</h2>
								<p className="card-category">
									Management of Subscribers and Plans stored in the PCRF
								</p>
							</div>

							<div className="card-body">
								{isVolTE ? (
									<h2 className="text-center text-secondary">
										SPR deactivated VolTE plan
									</h2>
								) : (
									<div className="tabs-container mt-4">
										<Tabs
											activeKey={key}
											// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
											onSelect={k => setKey(k!)}
											id="uncontrolled-tab">
											<Tab
												tabClassName={`${
													roles
														.find((str: string) => str?.includes('subscriber'))
														?.includes('subscriber')
														? ''
														: 'd-none'
												}`}
												eventKey="Search Profile"
												title={
													<>
														<RenderTabTitle
															active={key}
															isLoading={
																isLoadingProfile || isLoadingProfileGpsi
															}
															title="Search Profile"
														/>

														<Form onSubmit={e => handleSubmit(e, 'profile')}>
															<div className="row">
																<div className="col-md-12 d-flex">
																	<InputGroup className="mb-3">
																		<Form.Control
																			required
																			type="text"
																			className="form-control"
																			placeholder="UE Id (SUPI or GPSI)"
																			name="search"
																			defaultValue={''}
																			onChange={e =>
																				changeValueOfFind(e as never, 'profile')
																			}
																		/>
																		<Button
																			type="submit"
																			variant="secondary"
																			style={{color: 'white'}}>
																			Search
																		</Button>
																	</InputGroup>

																	<Button
																		disabled={isReadOnlySubscribers}
																		onClick={() =>
																			navigate('/subscriberProfile/detail')
																		}
																		type="button"
																		variant="primary"
																		style={{color: 'white'}}>
																		Create
																	</Button>
																</div>
															</div>
														</Form>
													</>
												}>
												{dataProfile && dataProfile?.data != null ? (
													<TableSubscritionProfile
														dataProfile={dataProfile.data as never}
														refetch={handleRefetch}
														type={dataProfile.type_search}
														isDisabled={isReadOnlySubscribers}
													/>
												) : (
													<RenderNoData />
												)}
											</Tab>
											<Tab
												tabClassName={`${
													roles
														.find((str: string) => str?.includes('plan'))
														?.includes('plan')
														? ''
														: 'd-none'
												}`}
												eventKey="Search Plan"
												title={
													<>
														<RenderTabTitle
															active={key}
															isLoading={isLoadingDataPlanTemplate}
															title="Search Plan"
														/>
														<Form onSubmit={e => handleSubmit(e, 'plan')}>
															<div className="row">
																<div className="col-md-12 d-flex">
																	<InputGroup className="mb-3">
																		<Form.Control
																			data-testid="btnTestId"
																			type="text"
																			className="form-control"
																			placeholder="Plan name"
																			name="search"
																			defaultValue={''}
																			onChange={e =>
																				changeValueOfFind(e as never, 'plan')
																			}
																		/>
																		<Button
																			type="submit"
																			variant="secondary"
																			style={{color: 'white'}}>
																			Search
																		</Button>
																	</InputGroup>

																	<Button
																		disabled={isReadOnlyPlan}
																		onClick={() =>
																			navigate('/subscriberPlan/detail/')
																		}
																		variant="primary"
																		style={{color: 'white'}}>
																		Create
																	</Button>
																</div>
															</div>
														</Form>
													</>
												}>
												{dataPlan && dataPlan?.data?.length > 0 ? (
													<TableSubscritionPlan
														dataPlan={dataPlan.data as never}
														onCleanPlans={handleCleanPlans}
														isDisabled={isReadOnlyPlan}
													/>
												) : (
													<RenderNoData />
												)}
											</Tab>
											{/*<Tab
												eventKey="Operators"
												title={
													<>
														<RenderTabTitle
															active={key}
															isLoading={isLoadingOperatorsPlanTemplate}
															title="Operators"
														/>
														<Form onSubmit={e => handleSubmit(e, 'operator')}>
															<div className="row">
																<div className="col-md-12 d-flex">
																	<InputGroup className="mb-3 mr-4">
																		<Button
																			type="submit"
																			variant="secondary"
																			style={{color: 'white'}}>
																			Search
																		</Button>
																	</InputGroup>

																	<Button
																		onClick={() =>
																			navigate('/subscriberOperators/detail/')
																		}
																		variant="primary"
																		style={{color: 'white', height: 34}}>
																		Create
																	</Button>
																</div>
															</div>
														</Form>
													</>
												}>
												{dataOperators && dataOperators?.data?.length > 0 ? (
													<TableSubscritionOperator
														dataOperators={dataOperators.data as never}
														onCleanOperators={handleCleanOperators}
													/>
												) : (
													<RenderNoData />
												)}
											</Tab>
											*/}
										</Tabs>
									</div>
								)}
							</div>
							<div className="card-footer">
								<hr />
								<div className="stats">
									<i className="bi-1 bi-clock-history" /> Updated {timeStr}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LayoutMain>
	);
};

export default SubscriberHome;
